import { useQuery } from '@apollo/client';

import { getVendorMenuTemplates } from '@/api';
import { resolveGqlErrors } from '@/helpers';

import type { MenuTemplateSummary } from '../types';

type UseVendorMenuTemplates = {
  templates: MenuTemplateSummary[];
  loading: boolean;
  error: string;
};

export const useVendorMenuTemplates = (vendorId: string | null): UseVendorMenuTemplates => {
  const { data, loading, error } = useQuery(getVendorMenuTemplates, {
    variables: { vendorId: vendorId ?? '' },
    skip: !vendorId,
    fetchPolicy: 'cache-first',
  });

  const templates: MenuTemplateSummary[] = data?.getVendorMenuTemplates?.menuTemplates ?? [];

  return {
    templates,
    loading,
    error: resolveGqlErrors(error || data?.getVendorMenuTemplates?.error),
  };
};
